import React, { useState } from 'react';

import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import { debounce } from 'lodash';

import FilterApptStatusSelect from './FilterApptStatusSelect';
import FixedFiltersHeader from '../FixedFiltersHeader';

const styles = () =>
  createStyles({
    contentWrapper: {
      display: 'flex',
      flexDirection: 'column',
    },
  });

interface FiltersSelectApptTypeProps extends WithStyles<typeof styles> {
  items: any[];
  type: string;
}

const FiltersSelectApptType: React.FC<FiltersSelectApptTypeProps> = ({ classes, items, type }) => {
  const [localItems, setLocalItems] = useState(items);

  const handleSearch = (value: string) => {
    const searchValue = value.toLowerCase();
    const filteredItems = items.filter(
      (item: any) => item._id.toLowerCase().includes(searchValue) || item.label.toLowerCase().includes(searchValue),
    );

    setLocalItems(filteredItems);
  };

  return (
    <div className={classes.contentWrapper}>
      <FixedFiltersHeader items={items} type={type} onSearchChange={debounce(handleSearch, 300)} />
      <FilterApptStatusSelect staticData={localItems} type={type} />
    </div>
  );
};

export default withStyles(styles)(FiltersSelectApptType);
